import "./index.css";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import ModalPopup from "./components/common/ModalPopup";
import ConfirmPopup from "./components/common/ConfirmPopup";
import LoadSpinner from "./components/common/LoadSpinner";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <>
        <LoadSpinner />
        <ModalPopup />
        <ConfirmPopup />
        <App />
      </>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
